import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=2fe247b4&scoped=true"
import script from "./cooperation.vue?vue&type=script&lang=js"
export * from "./cooperation.vue?vue&type=script&lang=js"
import style1 from "./cooperation.vue?vue&type=style&index=1&id=2fe247b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe247b4",
  null
  
)

export default component.exports